import Layout from "./Layout"

const EnableToken = () =>{

    return<Layout></Layout>
}

export default EnableToken